<template>
  <div id="step1" >
    <div id="first_row" class="row justify-content-center align-items-center">
      <PelotitasPasos :infostep="'Datos del vehículo'" />
    </div>
    <fieldset :class="{ cambio_paso: transicion }">
      <!--#NF El estado de transicion es un pequeño destello que se da al completar la pregunta de un step, mas info en app.scss-->
      <div class="row justify-content-center pt-2 d-none d-lg-flex hidden-md-and-down">
        <div class="col-10 col-sm-7 col-md-6 col-lg-10 col-xl-10">
          <div class="row justify-content-center">
            <div class="text-center">
              <img src="../../../public/avatar_58.png" class="rounded image-icon" />
            </div>
          </div>
        </div>
      </div>
      <div id="cards_row_form" class="row justify-content-center pt-4">
        <div class="col-10 col-sm-10 col-md-11 col-lg-6 col-xl-6">
          <div class="row justify-content-center">
            <p class="text-center slogan1">Selecciona los kilómetros de tu coche, para su valoración.</p>
          </div>
          <div class="row justify-content-center">
            <p class="text-center slogan2">¿Cuántos kilómetros tiene?</p>
          </div>

          <div class="row justify-content-center text-center mt-3">
            <div class="col-12">
              <div class="row justify-content-center">
                <div class="card-columns">
                  <div class="card" :class="{ active: getKms() == 25000 }" @click="setKilometros(25000)">
                    <!-- TODO:  Estas cards no se ven bien en IPHONE  -->
                    <div class="card-body">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="font-weight-bold">Menos de <br class="d-none d-sm-none d-md-block d-lg-block d-xl-block" > 50.000 km</span>
                      </div>
                    </div>
                  </div>
                  <div class="card" :class="{ active: getKms() == 125000 }" @click="setKilometros(125000)">
                    <div class="card-body">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="font-weight-bold">100.000 -<br class="d-none d-sm-none d-md-block d-lg-block d-xl-block" > 150.000 km</span>
                      </div>
                    </div>
                  </div>
                  <div class="card" :class="{ active: getKms() == 225000 }" @click="setKilometros(225000)">
                    <div class="card-body">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="font-weight-bold">200.000 -<br class="d-none d-sm-none d-md-block d-lg-block d-xl-block" > 250.000 km</span>
                      </div>
                    </div>
                  </div>
                  <div class="card" :class="{ active: getKms() == 300000 }" @click="setKilometros(300000)">
                    <div class="card-body">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="font-weight-bold">Más de <br class="d-none d-sm-none d-md-block d-lg-block d-xl-block" > 300.000 km</span>
                      </div>
                    </div>
                  </div>
                  <div class="card" :class="{ active: getKms() == 75000 }" @click="setKilometros(75000)">
                    <div class="card-body">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="font-weight-bold">50.000 -<br class="d-none d-sm-none d-md-block d-lg-block d-xl-block" > 100.000 km</span>
                      </div>
                    </div>
                  </div>
                  <div class="card" :class="{ active: getKms() == 175000 }" @click="setKilometros(175000)">
                    <div class="card-body">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="font-weight-bold">150.000 -<br class="d-none d-sm-none d-md-block d-lg-block d-xl-block" > 200.000 km</span>
                      </div>
                    </div>
                  </div>
                  <div class="card" :class="{ active: getKms() == 275000 }" @click="setKilometros(275000)">
                    <div class="card-body">
                      <div class="d-flex justify-content-center align-items-center">
                        <span class="font-weight-bold">250.000 -<br class="d-none d-sm-none d-md-block d-lg-block d-xl-block" > 300.000 km</span>
                      </div>
                    </div>
                  </div>
                  <div class="card" style="border: none; box-shadow: none; background-color: white">
                    <!-- Este div es necesario para que se muestre los cards correctamente porque el nº de cards es impar -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <div id="fourth_row_form" class="row justify-content-center pt-2 d-none d-md-flex hidden-md-and-down">
      <div class="col-12">
        <div class="row justify-content-center">
          <p class="text-center slogan1">- El único préstamo con el coche como garantía -</p>
        </div>
      </div>
    </div>
    <BotonVolver />
  </div>
</template>

<script>
import store from "@/store";
import { mapState } from "vuex";
import BotonVolver from "./BotonVolver.vue";
import PelotitasPasos from "./PelotitasPasos.vue";

export default {
  name: "NewStep1A",
  data: function () {
    return {
      transicion: false,
      windowWidth: window.innerWidth,
    };
  },
  store,
  computed: mapState({
    step: (state) => state.formulario.step,
    data_matricula: (state) => state.formulario.data_matricula,
    formulario: (state) => state.formulario,
    afiliado: (state) => state.afiliado,
  }),
  components: { PelotitasPasos, BotonVolver },
  methods: {
    getKms: function () {
      return this.formulario.kms;
    },


    setKilometros(kilometros) {
      store.commit("setKms", kilometros);
      this.transicion = true;
      setTimeout(() => {
        this.$router.push("step1b");
      }, 400);
    },
    getWindowWidth() {
      this.windowWidth = window.innerWidth;
    }
  },
  created: function () {
    window.dataLayer = window.dataLayer || []; //LLAMADA GOOGLE TAG

    window.dataLayer.push({
      event: "kilometros",
      'idAfiliado': this.afiliado
    });
  },
  watch: {
    windowWidth(value) {
      const menu = document.querySelector('#navigation_menu');
      if (value >= 992) {
        menu.style.display = 'block';
      }else{
        menu.style.display = 'none';
      }
    }
  },
  mounted: function () {
    store.commit("setStep", "1a");
    //Set color de las bolitas que indican el cambio de paso
    store.commit("setBarraColor1", "azul-blanco");
    store.commit("setCheckColor2", "blanco");
    store.commit("setBarraColor2", "blanco");
    store.commit("setCheckColor3", "blanco");
    const menu = document.querySelector('#navigation_menu');
    if (window.innerWidth >= 992) {
      menu.style.display = 'block';
    }else{
      menu.style.display = 'none';
    }
    window.addEventListener('resize', this.getWindowWidth);
  },
};
</script>

<style lang="scss">
@import "bootstrap/scss/_functions.scss";
@import "bootstrap/scss/_variables.scss";
@import "bootstrap/scss/_mixins.scss";
@include media-breakpoint-only(md) {
  #navigation_menu {
    display: none;
  }
}

@include media-breakpoint-only(sm) {
  #navigation_menu {
    display: none;
  }
}
@include media-breakpoint-only(xs) {
  #navigation_menu {
    display: none;
  }
}
#footer-mobile {
  // No queremos que se vea el footer de primeras en mobile, añadiremos un margin adaptado a cada pantalla del form

  margin-top: 30%;
}
</style>

<style scoped lang="scss">
@import "bootstrap/scss/_functions.scss";
@import "bootstrap/scss/_variables.scss";
@import "bootstrap/scss/_mixins.scss";

#step1 {
  height: 100%;
  .contenedor {
    position: relative;
    text-align: center;
    color: white;
  }
  .centered {
    position: absolute;
    top: 82%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #004680;
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
  }

  #image_formulario {
    background-repeat: no-repeat;
    background-size: cover;
  }

  #cards_row_form {
    margin-top: 20px;
  }

  .card {
    background-color: white;
    border: 2px solid rgba(196, 196, 196, 0.4);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    &:hover {
      background-color: #004680;
      color: white;
      border: 2px solid rgba(196, 196, 196, 0.4);
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
      border-radius: 10px;
      cursor: pointer;
    }
    &:active {
      background-color: #004680;
      color: white;
      border: 2px solid rgba(196, 196, 196, 0.4);
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
      border-radius: 10px;
    }
  }

  .active {
    background-color: #004680;
    color: white;
    border: 2px solid rgba(196, 196, 196, 0.4);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
  }
}

@include media-breakpoint-only(xs) {
  #step1 {
    .slogan1 {
      color: #004680;
      font-size: 16px;
      font-weight: 600;
    }
    #cards_row_form {
      margin-top: 0px;
    }
    .slogan2 {
      font-size: 18px;
      font-family: "Montserrat-Bold";
    }

    #image_formulario {
      margin-top: 90px;
      width: 100%;
      height: 375px;
    }

    #first_row {
      height: 85px;
      max-height: 220px;
      background-color: #b3dcff;
    }

    .card-columns {
      column-count: 2;
      max-width: 100%;
      width: 100%;
    }
    .card {
      width: 149px;
      height: 90px;
    }
    .card:hover {
      width: 149px;
      height: 90px;
    }
    .card-body {
      padding: 1rem !important;
    }
    .volver {
      font-size: 14px;
      font-weight: 400;
      opacity: 0.6;
      color: #999999;
    }
    .volver_circle {
      height: 35px;
      width: 35px;
      display: table-cell;
      text-align: center;
      vertical-align: middle;
      border: solid 1px #dadada;
      border-radius: 50%; /* may require vendor prefixes */
      background: #fff;
    }
  }
}

@include media-breakpoint-only(sm) {
  #step1 {
    .slogan1 {
      color: #004680;
      font-size: 16px;
      font-weight: 600;
    }
    .slogan2 {
      font-size: 18px;
      font-family: "Montserrat-Bold";
    }
    #image_formulario {
      margin-top: 90px;
      width: 100%;
      height: 375px;
    }

    #first_row {
      height: 86px;
      max-height: 220px;
      background-color: #b3dcff;
    }

    .card-columns {
      column-count: 2;
      max-width: 100%;
      width: 100%;
    }
    .card {
      width: 220px;
      height: auto;
    }
    .card:hover {
      width: 220px;
      height: auto;
    }
  }
}

@include media-breakpoint-only(md) {
  fieldset {
    margin: -2vh 15% 5vh 15%;
    padding: 2%;
  }
  #step1 {
    .slogan1 {
      color: #004680;
      font-size: 16px;
      font-weight: 600;
    }
    .slogan2 {
      font-size: 18px;
      font-family: "Montserrat-Bold";
    }
    #image_formulario {
      margin-top: 90px;
      width: 100%;
      height: 325px;
    }
    #first_row {
      min-width: 320px;
      width: 100%;
      height: 97px;
      max-height: 220px;
      background-color: #b3dcff;
      // margin-top: 100px;
    }
    .card-columns {
      column-count: 2;
      max-width: 100%;
      width: 99%;
    }
  }
}

@include media-breakpoint-only(lg) {

  fieldset {
    margin: 5vh 15% 5vh 15%;
    padding: 2%;

    border: 1px #b3dcff solid;
  }
  #step1 {
    margin-top: 90px;

    .slogan1 {
      color: #004680;
      font-size: 20px;
      font-weight: 600;
    }
    .slogan2 {
      font-size: 22px;
      font-family: "Montserrat-Bold";
    }
    #image_formulario {
      margin-top: 90px;
      width: 100%;
      height: 375px;
    }
    #first_row {
      min-width: 320px;
      width: 100%;
      height: 97px;
      max-height: 220px;
      background-color: #b3dcff;
      // margin-top: 100px;
    }
    .card-columns {
      column-count: 2;
      max-width: 100%;
      width: 99%;
    }
  }
}

@include media-breakpoint-only(xl) {

  fieldset {
    margin: 5vh 15% 5vh 15%;
    padding: 2%;

    border: 1px #b3dcff solid;
  }
  #step1 {
    .slogan1 {
      color: #004680;
      font-size: 20px;
      font-weight: 600;
    }
    .slogan2 {
      font-size: 22px;
      font-family: "Montserrat-Bold";
    }
    #image_formulario {
      margin-top: 90px;
      width: 100%;
      height: 525px;
    }
    #first_row {
      min-width: 320px;
      width: 100%;
      height: 97px;
      max-height: 220px;
      background-color: #b3dcff;
      margin-top: 90px;
    }
    .card-columns {
      column-count: 2;
      max-width: 100%;
      width: 99%;
    }
  }
}
</style>
